import React from 'react';
import {
    Box, Grid, Card, CardContent, Typography, Avatar, Chip, Stack, useTheme, Zoom, IconButton
} from '@mui/material';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import SportsSoccerRoundedIcon from '@mui/icons-material/SportsSoccerRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';

const MemberList = ({ members, onProfileClick, onEditClick, canEdit }) => {
    const theme = useTheme();

    return (
        <Grid container spacing={3} sx={{ width: '100%' }}>
            {members.map((m, idx) => (
                <Grid key={m.id} sx={{ width: '100%' }}>
                    <Zoom in={true} style={{ transitionDelay: `${idx * 40}ms` }}>
                        <Card 
                            onClick={() => onProfileClick?.(m)}
                            sx={{ 
                                height: '100%',
                                cursor: 'pointer',
                                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                borderRadius: "12px",
                                border: '1px solid',
                                borderColor: 'divider',
                                background: 'rgba(255,255,255,0.01)',
                                position: 'relative',
                                overflow: 'visible',
                                '&:hover': { 
                                    transform: 'translateY(-8px)',
                                    borderColor: 'primary.main',
                                    bgcolor: 'rgba(190, 242, 100, 0.02)',
                                    boxShadow: `0 20px 40px rgba(0, 0, 0, 0.12), 0 0 20px rgba(190, 242, 100, 0.08)`
                                }
                            }}
                        >
                            {canEdit && (
                                <IconButton
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onEditClick?.(m);
                                    }}
                                    sx={{
                                        position: 'absolute',
                                        top: 12,
                                        right: 12,
                                        zIndex: 1,
                                        bgcolor: 'background.paper',
                                        boxShadow: 1,
                                        '&:hover': { bgcolor: 'background.default' }
                                    }}
                                    size="small"
                                >
                                    <EditRoundedIcon fontSize="small" />
                                </IconButton>
                            )}

                            <CardContent sx={{ p: 2 }}>
                                <Stack direction="row" spacing={2.5} alignItems="center">
                                    <Box sx={{ position: 'relative' }}>
                                        <Avatar 
                                            sx={{ 
                                                width: 64, 
                                                height: 64, 
                                                bgcolor: m.team_role === 'trainer' ? 'primary.main' : 'background.paper',
                                                color: m.team_role === 'trainer' ? '#000' : 'text.primary',
                                                fontWeight: 900,
                                                fontSize: '1.2rem',
                                                border: '2px solid',
                                                borderColor: m.team_role === 'trainer' ? 'primary.main' : 'divider',
                                                boxShadow: m.team_role === 'trainer' ? '0 0 15px rgba(190, 242, 100, 0.4)' : 'none'
                                            }}
                                        >
                                            {m.first_name?.[0] || ''}{m.last_name?.[0] || ''}
                                        </Avatar>
                                        {m.team_role === 'trainer' && (
                                            <VerifiedRoundedIcon 
                                                sx={{ 
                                                    position: 'absolute', 
                                                    bottom: -2, 
                                                    right: -2, 
                                                    color: 'primary.main',
                                                    bgcolor: '#000',
                                                    borderRadius: "12px",
                                                    fontSize: 20
                                                }} 
                                            />
                                        )}
                                    </Box>
                                    <Box sx={{ overflow: 'hidden' }}>
                                        <Typography variant="h6" sx={{ fontWeight: 900, lineHeight: 1.2, mb: 0.5, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            {m.first_name} {m.last_name}
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: 'primary.main', fontWeight: 900, textTransform: 'uppercase', letterSpacing: '0.1em', fontSize: '0.7rem' }}>
                                            {m.team_role === 'trainer' ? 'Trainer' : 'Spieler'}
                                        </Typography>
                                    </Box>
                                </Stack>

                                <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mb: 0, gap: 1 }}>
                                    {(m.sekundaer_rolle || '').toString().split(',').map((r, i) => r.trim()).filter(Boolean).map((r, i) => (
                                        <Chip
                                            key={i}
                                            label={r}
                                            size="small"
                                            sx={{
                                                bgcolor: 'rgba(255,255,255,0.05)',
                                                color: 'text.primary',
                                                fontWeight: 800,
                                                fontSize: '0.65rem',
                                                borderRadius: "12px",
                                                border: '1px solid rgba(255,255,255,0.1)'
                                            }}
                                        />
                                    ))}
                                </Stack>
                            </CardContent>
                        </Card>
                    </Zoom>
                </Grid>
            ))}
        </Grid>
    );
};

export default MemberList;
